import styles from "./faq.module.css";
import ArrowDownTight from "../../images/arrow-down-tight.svg";
import React from "react";
import {useFaq} from "./useFaq";
import clsx from "classnames";

export const Faq = () => {
  const {questions, onToggleOpen} = useFaq();

  const onClickHandlerYM = () => {
    if (window.ym) {
      window.ym(96742836, 'reachGoal', `clck-mn-faq-blck`);
    }
  }

  return (
    <div className={styles.faq} onClick={onClickHandlerYM}>
      <div className="content">
        <h2 className={styles.question}>Часто задаваемые вопросы</h2>
        <div className={styles.wrapperQuestions}>
          {questions && (
            questions.map((item) => (
              <div key={item.id} className={styles.questionItem}>
                <div className={styles.questionItemHeader}>
                  <h3 className={styles.questionSubtitle}>{item.title}</h3>

                  <div className={styles.close} onClick={() => onToggleOpen(item.id)}>
                    <img className={clsx({
                      [styles.rotate]: item.open
                    })} src={ArrowDownTight} alt="close"/>
                  </div>
                </div>
                <div className={clsx({
                  [styles.questionItemAnswer]: true,
                  [styles.questionItemAnswerDotted]: item.descr.length > 1
                })}>
                  {item.open &&
                    item.descr.map((line, index) => (
                      <p key={index} className={styles.paragraph}>
                        {line}
                      </p>
                    ))}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
